/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import { loadCdnScripts } from "@ecom/ui/utils/api"
import "./src/styles/index.scss"

export const onClientEntry = () => {
  loadCdnScripts()
}